import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "@assets/images/logo.png";

const Splash: React.FC = () => {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const splashShown = sessionStorage.getItem("splashShown");

		if (splashShown) {
			setIsVisible(false);
			return;
		}

		const timer = setTimeout(() => {
			setIsVisible(false);
			sessionStorage.setItem("splashShown", "true");
		}, 3000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<AnimatePresence>
			{isVisible && (
				<motion.div
					key="splash"
					className="fixed inset-0 z-50 flex items-center justify-center bg-white"
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0, transition: { duration: 0.5 } }}
				>
					<motion.img
						src={logo}
						alt="Company Logo"
						className="w-80"
						/*
              We’re animating the ‘y’ property to create a bounce from above:
              - Starts off-screen (-300px)
              - Drops down (0)
              - Goes slightly back up (-20)
              - Settles at 0
            */
						initial={{ y: -300, opacity: 0 }}
						animate={{
							y: [-300, 0, -20, 0],
							opacity: 1,
						}}
						exit={{ y: -300, opacity: 0, transition: { duration: 0.5 } }}
						transition={{
							duration: 1, // Adjust total time for the sequence
							ease: "easeInOut",
						}}
					/>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default Splash;
